import React, { useState } from 'react';
import { ErrorMessage } from '@hookform/error-message';
import { useForm, Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Form } from 'reactstrap';
import UserService from 'views/User/service';
import FlexSelect from 'components/Inputs/FlexSelect';
import { useQueueChatPauseContext } from '../../../../../../hooks/useQueuePauseChatServicePanel';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import { UserInfoWrapper, Button, Label } from './styled';
import { useConversationConnectionSocketForMonitoring } from 'hooks/useConversationConnectionSocketForMonitoring';

export function LoginChatForm({ agentName }) {
  const [loading, setLoading] = useState(false);
  const [userQueueIds, setUserQueueIds] = useState([]);
  const { handleLoginInTheQueuesChat, queues } = useQueueChatPauseContext();
  const { emitEventUpdateQueueChatCache } =
    useConversationConnectionSocketForMonitoring();

  const { control, handleSubmit, errors, setValue } = useForm();
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  React.useEffect(() => {
    const fetchUserQueues = async () => {
      try {
        const login = localStorage.getItem('login') || '';
        const response = await UserService.getAllSeachUser(
          1,
          10,
          login,
          false,
          '',
          'name',
          'asc',
          'contexto'
        );
        const userList = response.data?.data;
        if (Array.isArray(userList) && userList.length > 0) {
          const userQueues = userList[0]?.queues || [];
          const queueIds = userQueues.map((q) => q.id);
          setUserQueueIds(queueIds);
        } else {
          setUserQueueIds([]);
        }
      } catch (e) {
        setUserQueueIds([]);
      }
    };
    fetchUserQueues();
  }, []);

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const newQueues = await handleLoginInTheQueuesChat(data.queueIds);
      emitEventUpdateQueueChatCache(newQueues, queues);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error('Erro ao logar nas filas do chat');
      console.log('err', err);
    }
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  return (
    <>
      <UserInfoWrapper title="Autenticação em filas do chat">
        Olá, {agentName} escolha as filas desejadas para começar o atendimento
      </UserInfoWrapper>
      <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-2">
          <Label>Filas*</Label>
          <Controller
            render={(props) => (
              <FlexSelect
                dataOptions={Array.from(queues?.values()).filter((q) => userQueueIds.includes(q.id))}
                isMulti={true}
                value={props.value}
                placeholder="Selecione uma ou mais filas"
                isClearable={true}
                valueController={setValue}
                closeMenuOnSelect={false}
                fieldName="queueIds"
                labelName="name"
                valueName="id"
              />
            )}
            defaultValue=""
            control={control}
            rules={{ required: 'Campo obrigatório!' }}
            name="queueIds"
          />
          <ErrorMessage
            errors={errors}
            name="queueIds"
            render={({ message }) => errorFormMessage(message)}
          />
        </div>

        <Button
          disabled={loading}
          type="submit"
          title="Inicar atendimento"
          style={buttonStyle(systemConfiguration.primary_color)}
        >
          Iniciar Atendimento
        </Button>
      </Form>
    </>
  );
}
